import { AccountPortal } from './AccountPortal'
import { CartButton } from './CartButton'
import { Checkout } from './Checkout'
import { ForgotPasswordForm } from './ForgotPasswordForm'
import { LoginButton } from './LoginButton'
import { LoginForm } from './LoginForm'
import { PlanPricing } from './PlanPricing'
import { PromoBanner } from './PromoBanner'
import { PromoPill } from './PromoPill'
import { ResetPasswordForm } from './ResetPasswordForm'
import { StickyPromo } from './StickyPromo'

/**
 * The public component catalogue. A name here is what marketing writes in a
 * Webflow Embed element: `<div data-cv="LoginButton"></div>`.
 *
 * Renaming a key is a breaking change to live pages — the markup referencing it
 * lives in Webflow, not in this repo.
 */
export const components = {
  AccountPortal,
  CartButton,
  Checkout,
  ForgotPasswordForm,
  LoginButton,
  LoginForm,
  PlanPricing,
  PromoBanner,
  PromoPill,
  ResetPasswordForm,
  StickyPromo,
}

export {
  AccountPortal,
  CartButton,
  Checkout,
  ForgotPasswordForm,
  LoginButton,
  LoginForm,
  PlanPricing,
  PromoBanner,
  PromoPill,
  ResetPasswordForm,
  StickyPromo,
}
